export const LABELS = {
    PROCEED_AND_PAY: "proceed-and-pay",
    REVIEW_ORDER: "review-order",
    REVIEW_CART: "review-cart",
    DISMISS: "dismiss",
    OK_GOT_IT: "okay-got-it",
    SEE_HOW: "see-how",
};
